<template>
  <layout>
    <page-header :header="$t('vehicles.vehicle_types.edit')" >
    </page-header>
    <div class="content">
      <resource-form
        :id="$route.params.id"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'vehicle-types'

export default {
  name: 'VehicleTypeEdit',

  components: {
    ResourceForm,
  },

  data() {
    return {
    }
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
